import styled from '@emotion/styled';

import type { SpacingUnit } from '@toolbox/style';
import type { Theme } from '@emotion/react';

export type ContainerProps = {
  maxW?: keyof Theme['sizes']['container'];
  spacing?: SpacingUnit | [SpacingUnit, SpacingUnit] | [SpacingUnit, SpacingUnit, SpacingUnit];
};

export const Container = styled('div', {
  shouldForwardProp: (prop: string) => !['maxW', 'spacing'].includes(prop),
})<ContainerProps>`
  width: 100%;
  margin: 0 auto;
  padding: ${({ theme, spacing = 4 }) => theme.spacing(...(ensureArray(spacing) as [SpacingUnit]))};
  max-width: ${({ maxW = 'lg', theme }) => theme.sizes.container[maxW]};
`;

function ensureArray<T>(value: T | T[]): T[] {
  return [value].flat() as T[];
}

Container.defaultProps = {
  maxW: 'lg',
};
